import VARS from '@assets/_vars.json'

const breakpoints = VARS.breakpoints

/**
 * Name normalization (camelCase -> kebab-case)
 */
function normalizeName(name) {
  if (!name) return ''
  return String(name)
    .replace(/[A-Z]/g, m => '-' + m.toLowerCase())
    .toLowerCase()
}

export function useBreakpoints() {
  /**
   * Return the number (px) for a specific breakpoint
   * @param {string} name  'mobile' | 'tablet-sm' | ...
   * @returns {number|string|null}
   */
  const get = (name) => {
    const key = normalizeName(name)

    if (!breakpoints[key]) {
      console.warn(`Breakpoint "${name}" not found.`)
      return null
    }

    return breakpoints[key]
  }

  return { breakpoints, get }
}
